import {Injectable, EventEmitter, Output} from '@angular/core';
import {EndpointService} from "../endpoint/endpoint.service";
import {Observable, Subject} from 'rxjs';
import {Board, BoardIdentifier, UserRelatedBoard, UserToBoardRelation} from '../../modele/boardModel';
import {UserService} from "../user.service";
import {NGXLogger} from "ngx-logger";
import {Topic} from "../../modele/topicModel";
import {User, Owner} from "../../modele/user/userModel";
import async from 'async';

@Injectable({
    providedIn: 'root'
})
export class BoardService {
    private get_boards_emitter: EventEmitter<Board> = new EventEmitter();
    private board_content_is_loading_emitter: EventEmitter<boolean> = new EventEmitter();
    private show_new_content_emitter: EventEmitter<boolean> = new EventEmitter();
    private log_prefix=this.constructor.name+":";
    private local_service_board_cache: Array<UserRelatedBoard> = [];
    private local_service_board_cache_sorted_by_board_id: Array<UserRelatedBoard> = [];
    private userRelatedBoardsSubject: Subject <Array<UserRelatedBoard>> = new Subject()
    private currentUser: User;
    private resolvingDataForUser: boolean = false;
    private changeDetectionSubject: Subject<string> = new Subject();

    @Output() data: EventEmitter<Board[]> = new EventEmitter<Board[]>();

    constructor(
        private endpointSrv: EndpointService,
        private userService: UserService,
        private logger: NGXLogger
    ){
        this.logger.info(this.log_prefix,"cons called");
        this.userService.getUserSubject().subscribe(user => {
            if(this.currentUser != user){
                this.logger.info(this.log_prefix, "got informed of user with id:", user.user_id);
                this.currentUser = user;
                this.resolveBoardDataForCurrentUser();
            } else {
                this.logger.warn(this.log_prefix,"got informed of user, that was already known");
            }
        });

        this.serviceInterfaceToInformOfChanges().subscribe(serviceThatRequestedChange => {
            this.logger.info(this.log_prefix,"service [",serviceThatRequestedChange,"]requested change");
            this.resolvingDataForUser = false;
            this.resolveBoardDataForCurrentUser();
        });
    }
    reload(){
        this.serviceInterfaceToInformOfChanges().subscribe(serviceThatRequestedChange => {
            this.logger.info(this.log_prefix,"service [",serviceThatRequestedChange,"]requested change");
            this.resolvingDataForUser = false;
            this.resolveBoardDataForCurrentUser();
        });
    }

    getAllBoardsForStartComponent(): Observable<Object> {
        return this.endpointSrv.getAllForSearch();
    }
    getBoardByName(board_name): Observable<Object> {
        return this.endpointSrv.getBoardByNameForBoardPage(board_name);
    }
    private getAllBoardsforLocalUser(): Observable<Object> {
        return this.endpointSrv.getAllBoardsforLocalUser();
    }
    resolveBoardDataForCurrentUser():any{
        if(this.currentUser.user_id > 0){
            this.logger.info(this.log_prefix,"have valid user > resolving board data");
            if(this.resolvingDataForUser === false){
                this.logger.info(this.log_prefix,"dont have data yet -> resolving now");
                this.resolvingDataForUser = true;
                async.waterfall([
                    done => {
                        this.logger.info(this.log_prefix,"have resolving boards for user_id:",this.currentUser.user_id)
                        if(this.currentUser.user_id != -1){
                            return done(null);
                        } else {
                            return done(new Error(this.log_prefix+"got informed of dummy user"));
                        }
                    },
                    (done) => {
                        this.getAllBoardsforLocalUser().subscribe(data => {

                            let userRelatedBoards = [];
                            this.local_service_board_cache = [];

                            userRelatedBoards.push(new UserToBoardRelation("all"));
                            userRelatedBoards.push(new UserToBoardRelation("own"));
                            let fakeMasonryBoard = new UserRelatedBoard(1400000000,
                                "createaboard",
                                "boardsfrombes.board_description",
                                1,
                                1,
                                false,
                                1,
                                1,
                                "assets/images/create.svg",
                                "255,255,255",
                                "keyword_$90",
                                new Owner(new User(1, "board_owner.user_name", "board_owner.user_avatar", 0),
                                    [new BoardIdentifier(2)]),
                                [new Topic(1, "sport", "main")],
                                userRelatedBoards,
                            );
                            this.local_service_board_cache.push(fakeMasonryBoard);
                            let boards = data['boards'];
                            boards.map((boardsfrombes) => {
                                let {board_owner} = boardsfrombes;
                                let userRelatedBoards = [];
                                boardsfrombes.relation.map(relations => {
                                    userRelatedBoards.push(new UserToBoardRelation(relations))
                                });
                                userRelatedBoards.push(new UserToBoardRelation("all"));
                                let parsedUserRelatedBoard = new UserRelatedBoard(boardsfrombes.board_id,
                                    boardsfrombes.board_name,
                                    boardsfrombes.board_description,
                                    boardsfrombes.board_follower_count,
                                    boardsfrombes.board_hits_count,
                                    boardsfrombes.session_user_follows,
                                    boardsfrombes.owner_id,
                                    boardsfrombes.topics_id,
                                    boardsfrombes.board_avatar,
                                    boardsfrombes.board_avatar_vibrant,
                                    boardsfrombes.board_screenname,
                                    new Owner(new User(board_owner.user_id, board_owner.user_name, board_owner.user_avatar, board_owner.user_is_verified),
                                        [new BoardIdentifier(2)]),
                                    [new Topic(boardsfrombes.topic_id, "sport", "main")],
                                    userRelatedBoards,
                                );
                                this.local_service_board_cache.push(parsedUserRelatedBoard);
                            });
                            return done(null, boards)
                        });
                    },
                    (resolvedBoards, done) => {
                        this.local_service_board_cache_sorted_by_board_id = this.local_service_board_cache;
                        this.local_service_board_cache_sorted_by_board_id.sort((b, a) => {
                            return <any>new Date(a.board_id['board_id']) - <any>new Date(b.board_id['board_id']);
                        });
                        this.logger.info(this.log_prefix,"sorted [",this.local_service_board_cache_sorted_by_board_id.length,"] boards")
                        return done(null, resolvedBoards, this.local_service_board_cache_sorted_by_board_id)
                    }
                ], (waterfallErr, resolvedBoards, sortedBoards)=>{
                    if(waterfallErr){
                        this.logger.warn(this.log_prefix,"have error in waterfall to auto resolve boards for current user:",waterfallErr.message);
                        throw waterfallErr;
                    }
                    this.logger.info(this.log_prefix,"successfully resolved and sorted [",sortedBoards.length, "] boards for uid:[",this.currentUser.user_id,"]");
                    this.userRelatedBoardsSubject.next(sortedBoards);
                });
            } else {
                this.logger.info(this.log_prefix,"already have data: have [", this.local_service_board_cache.length,"] boards")
            }
        } else {
            this.logger.info(this.log_prefix,"dont have valid user > not resolving board data");
        }
    }

    public getUserRelatedBoardsAsSubject(): Subject < Array<UserRelatedBoard >> {

        if(this.alreadyHaveResolvedUserRelatedBoards() === true){
            this.logger.info(this.log_prefix,"already have resolved boards: reemitting list with [",this.local_service_board_cache.length,"] boards")
            this.reEmitResolvedUserRelatedBoards();
        }
        return this.userRelatedBoardsSubject;
    }

    private alreadyHaveResolvedUserRelatedBoards(){
        let lp=this.log_prefix+"alreadyHaveResolvedUserRelatedBoards:"
        this.logger.info(lp,"called",this.currentUser != null, this.currentUser != null && this.currentUser.user_id != -1, this.local_service_board_cache.length > 0);
        if(this.currentUser != null && this.currentUser.user_id != -1 && this.local_service_board_cache.length > 0){
            return true;
        }
        return false;
    }

    private reEmitResolvedUserRelatedBoards(): void {
        if (this.local_service_board_cache != null) {
            this.logger.info(this.log_prefix, "remit called -> sending user related boards [", this.local_service_board_cache.length, "]");
            setTimeout(() => {
                this.userRelatedBoardsSubject.next(this.local_service_board_cache);
            }, 50);

        } else {
            this.logger.info(this.log_prefix, "remit called before user was resolved");
        }
    }

    public serviceInterfaceToInformOfChanges():Subject <string>{
        return this.changeDetectionSubject;
    }
    public contentIsFinishLoading(state){
        this.board_content_is_loading_emitter.emit(state);
    }
    public contentIsFinishLoadingEmitter():EventEmitter<boolean>{
        return this.board_content_is_loading_emitter;
    }
    public showNewContent(state){
        this.show_new_content_emitter.emit(state);
    }
    public showNewContentEmitter():EventEmitter<boolean>{
        return this.show_new_content_emitter;
    }

}
